/* Miniature houses: the house is cut out of its photo and breaks into pieces that fly in one after another.
   Drag sideways (mouse or finger) or use the slider / button to build it up or take it apart. No libraries.
   Data: assets/mh-asm-<handle>.json (pieces) + .webp (the cut-out), made by ~/.claude/skills/maksu-house-assemble/tools/make_assembly.py */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function rng(seed) { var s = seed * 9301 + 49297; return function () { s = (s * 9301 + 49297) % 233280; return s / 233280; }; }
  function ease(t) { var c = 1.35; t = t - 1; return 1 + (c + 1) * t * t * t + c * t * t; }   // easeOutBack: a little "tyk" at the end

  function init(root) {
    if (root.__asm) return; root.__asm = true;
    var cv = root.querySelector('[data-asm-cv]'); if (!cv) return;
    var ctx = cv.getContext('2d'), range = root.querySelector('[data-mh-range]'), nEl = root.querySelector('[data-mh-n]'), btn = root.querySelector('[data-mh-play]');
    var total = parseInt(root.getAttribute('data-parts'), 10) || 100;
    var txtBuild = btn ? btn.getAttribute('data-build') : '', txtTake = btn ? btn.getAttribute('data-take') : '';
    var data = null, img = new Image(), base = new Image(), p = 0, raf = 0, ready = false, W = 0, H = 0, scale = 1, dpr = 1;
    var hint = root.querySelector('.mh__hint');

    function layout() {
      if (!data) return;
      var w = cv.parentNode.clientWidth || 440; dpr = Math.min(2, window.devicePixelRatio || 1);
      scale = w / (data.w + 170); W = w; H = Math.round((data.h + 260) * scale);
      cv.style.width = W + 'px'; cv.style.height = H + 'px'; cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      draw();
    }
    function setP(v) {
      p = Math.max(0, Math.min(1, v));
      var n = Math.round(p * total); if (nEl) nEl.textContent = n;
      if (range) range.value = Math.round(p * 1000);
      if (btn) btn.textContent = p > 0.5 ? txtTake : txtBuild;
      draw();
    }

    function drawVec() {
      ctx.setTransform(dpr * scale, 0, 0, dpr * scale, 0, 0);
      ctx.clearRect(0, 0, W / scale, H / scale);
      var ox = 85, oy = 150;
      ctx.save(); ctx.strokeStyle = 'rgba(244,232,200,.07)'; ctx.lineWidth = 1 / scale;
      for (var gx = 0; gx < W / scale; gx += 28) { ctx.beginPath(); ctx.moveTo(gx, 0); ctx.lineTo(gx, H / scale); ctx.stroke(); }
      for (var gy = 0; gy < H / scale; gy += 28) { ctx.beginPath(); ctx.moveTo(0, gy); ctx.lineTo(W / scale, gy); ctx.stroke(); }
      ctx.restore();
      ctx.save(); ctx.translate(ox, oy);
      var N = data.pieces.length, span = 0.72, dur = 0.28, INK = '244,234,208';
      ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      for (var i = 0; i < N; i++) {
        var pc = data.pieces[i], t = (p - (i / N) * span) / dur;
        if (t <= 0) continue; if (t > 1) t = 1;
        var e = ease(t), k = 1 - e, draw = Math.max(0, Math.min(1, (t - 0.05) / 0.75));
        ctx.save();
        ctx.translate(pc.cx + pc.dx * k, pc.cy + pc.dy * k); ctx.rotate(pc.rot * k); var sc = 1 + (pc.s0 - 1) * k; ctx.scale(sc, sc); ctx.translate(-pc.cx, -pc.cy);
        // the part hides whatever drawn lines are behind it (fades in as it settles)
        ctx.save(); ctx.globalCompositeOperation = 'destination-out'; ctx.globalAlpha = Math.pow(t, 3);
        ctx.beginPath(); var q = pc.occ; ctx.moveTo(q[0], q[1]); for (var j = 2; j < q.length; j += 2) ctx.lineTo(q[j], q[j + 1]); ctx.closePath(); ctx.fill(); ctx.restore();
        if (pc.clip) { ctx.beginPath(); var c = pc.clip; ctx.moveTo(c[0], c[1]); for (var m = 2; m < c.length; m += 2) ctx.lineTo(c[m], c[m + 1]); ctx.closePath(); ctx.clip(); }
        if (pc.hatch) {
          ctx.save(); ctx.beginPath(); ctx.moveTo(q[0], q[1]); for (var h2 = 2; h2 < q.length; h2 += 2) ctx.lineTo(q[h2], q[h2 + 1]); ctx.closePath(); ctx.clip();
          ctx.strokeStyle = 'rgba(' + INK + ',' + (0.30 * draw).toFixed(3) + ')'; ctx.lineWidth = 0.8; var a = pc.hatch.a * Math.PI / 180, g = pc.hatch.g, R = 700;
          ctx.translate(pc.cx, pc.cy); ctx.rotate(a); ctx.beginPath(); for (var yy = -R; yy < R; yy += g) { ctx.moveTo(-R, yy); ctx.lineTo(R, yy); } ctx.stroke(); ctx.restore();
        }
        // pencil: two slightly different passes, drawn along each line up to `draw`
        for (var pass = 0; pass < 2; pass++) {
          ctx.strokeStyle = 'rgba(' + INK + ',' + (pass ? 0.40 : 0.92) + ')'; ctx.lineWidth = pass ? 0.9 : 1.5;
          for (var s = 0; s < pc.js.length; s++) {
            var st = pc.js[s], arr = pass ? st.b : st.a, lim = st.L * draw, acc = 0;
            if (lim <= 0) continue;
            ctx.beginPath(); ctx.moveTo(arr[0], arr[1]);
            for (var v = 2; v < arr.length; v += 2) {
              var sl = Math.hypot(st.a[v] - st.a[v - 2], st.a[v + 1] - st.a[v - 1]);
              if (acc + sl <= lim) { ctx.lineTo(arr[v], arr[v + 1]); acc += sl; }
              else { var f = (lim - acc) / Math.max(1e-6, sl); ctx.lineTo(arr[v - 2] + (arr[v] - arr[v - 2]) * f, arr[v - 1] + (arr[v + 1] - arr[v - 1]) * f); break; }
            }
            ctx.stroke();
          }
        }
        ctx.restore();
      }
      ctx.restore();
    }
    function draw() {
      if (!ready) return;
      if (vec) return drawVec();
      ctx.setTransform(dpr * scale, 0, 0, dpr * scale, 0, 0);
      ctx.clearRect(0, 0, W / scale, H / scale);
      var ox = 85, oy = 150;                                     // room around the house for pieces flying in
      ctx.save(); ctx.strokeStyle = 'rgba(244,232,200,.07)'; ctx.lineWidth = 1 / scale; for (var gx = 0; gx < W / scale; gx += 28) { ctx.beginPath(); ctx.moveTo(gx, 0); ctx.lineTo(gx, H / scale); ctx.stroke(); } for (var gy = 0; gy < H / scale; gy += 28) { ctx.beginPath(); ctx.moveTo(0, gy); ctx.lineTo(W / scale, gy); ctx.stroke(); } ctx.restore();
      ctx.save(); ctx.translate(ox, oy);
      // soft floor shadow
      var ex = data.w * 0.5, ey = data.h * 0.93;
      ctx.save(); ctx.globalAlpha = 0.04 + 0.1 * p; ctx.fillStyle = '#000'; ctx.beginPath(); ctx.ellipse(ex, ey, data.w * (0.30 + 0.2 * p), data.h * 0.07, 0, 0, 6.3); ctx.fill(); ctx.restore();
      if (p >= 0.999) { ctx.drawImage(img, 0, 0); ctx.restore(); return; }
      // faint outline of the empty spot
      ctx.save(); ctx.globalAlpha = 0.09 * (1 - p); ctx.drawImage(img, 0, 0); ctx.restore();
      var N = data.pieces.length, span = 0.7, dur = 0.3;
      for (var i = 0; i < N; i++) {
        var pc = data.pieces[i], t = (p - (i / N) * span) / dur;
        if (t <= 0) continue; if (t > 1) t = 1;
        var e = ease(t), k = 1 - e, r = pc.r;
        ctx.save();
        ctx.translate(pc.cx + pc.dx * k, pc.cy + pc.dy * k); ctx.rotate(pc.rot * k); var sc = 1 + (pc.s0 - 1) * k; ctx.scale(sc, sc); ctx.translate(-pc.cx, -pc.cy);
        ctx.globalAlpha = Math.min(1, t * 2.4);
        ctx.beginPath(); var q = pc.p; ctx.moveTo(q[0], q[1]); for (var j = 2; j < q.length; j += 2) ctx.lineTo(q[j], q[j + 1]); ctx.closePath(); ctx.clip();
        if (t < 1 && pc.bb) { var wp = Math.min(1, t * 1.25); ctx.beginPath(); ctx.rect(pc.bb[0] - 4, pc.bb[1] - 4, (pc.bb[2] - pc.bb[0] + 8) * wp, pc.bb[3] - pc.bb[1] + 8); ctx.clip(); }   // the pencil draws the piece from left to right
        ctx.drawImage(pc.b ? base : img, 0, 0);
        ctx.restore();
      }
      ctx.restore();
    }
    function tween(to, ms) {
      if (raf) cancelAnimationFrame(raf);
      if (reduce) { setP(to); return; }
      var from = p, t0 = performance.now(); ms = ms * Math.max(0.25, Math.abs(to - from));
      (function step(t) { var k = Math.min(1, (t - t0) / ms); setP(from + (to - from) * (k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2)); raf = k < 1 ? requestAnimationFrame(step) : 0; })(t0);
    }
    function touched() { root.classList.add('is-touched'); }

    if (range) range.addEventListener('input', function () { if (raf) { cancelAnimationFrame(raf); raf = 0; } touched(); setP(+range.value / 1000); });
    if (btn) btn.addEventListener('click', function () { touched(); tween(p > 0.5 ? 0 : 1, 4800); });
    // drag the picture sideways: right builds, left takes apart
    var down = false, sx = 0, sp = 0, moved = false;
    cv.addEventListener('pointerdown', function (e) { down = true; moved = false; sx = e.clientX; sp = p; if (raf) { cancelAnimationFrame(raf); raf = 0; } try { cv.setPointerCapture(e.pointerId); } catch (er) {} });
    cv.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; if (moved) { touched(); setP(sp + dx / (W * 0.8)); } });
    var up = function () { if (down && !moved) { touched(); tween(p > 0.5 ? 0 : 1, 4800); } down = false; };
    cv.addEventListener('pointerup', up); cv.addEventListener('pointercancel', function () { down = false; });
    cv.setAttribute('tabindex', '0');
    cv.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { touched(); setP(p + 0.05); } else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { touched(); setP(p - 0.05); } });
    window.addEventListener('resize', layout);
    if (window.ResizeObserver) new ResizeObserver(layout).observe(cv.parentNode);

    var vec = false;
    var done = 0, need = root.getAttribute('data-asm-base') ? 3 : 2;
    function go() {
      if (++done < need) return;
      var rnd = rng(7);
      if (data.parts) { vec = true; data.pieces = data.parts; }
      data.pieces.forEach(function (pc, i) {
        if (vec) {                                    /* pencil strokes: a jittered copy of every polyline, its length, and a bounding box */
          var xs0 = [], ys0 = []; pc.len = 0; pc.js = pc.s.map(function (st) {
            var out = [], L = 0, k; for (k = 0; k < st.length; k += 2) { out.push(st[k] + (rnd() - 0.5) * 1.1, st[k + 1] + (rnd() - 0.5) * 1.1); xs0.push(st[k]); ys0.push(st[k + 1]); if (k) L += Math.hypot(st[k] - st[k - 2], st[k + 1] - st[k - 1]); }
            return { a: st, b: out, L: L }; });
          pc.cx = (Math.min.apply(null, xs0) + Math.max.apply(null, xs0)) / 2; pc.cy = (Math.min.apply(null, ys0) + Math.max.apply(null, ys0)) / 2;
          pc.p = pc.occ;
        }
        var a = -Math.PI / 2 + (rnd() - 0.5) * 3.6, d = 110 + rnd() * 230;
        pc.dx = Math.cos(a) * d + (pc.cx - data.w / 2) * 0.5; pc.dy = Math.sin(a) * d - 30;
        pc.rot = (rnd() - 0.5) * 1.5; pc.s0 = 0.55 + rnd() * 0.35;
        var xs = [], ys = []; for (var u = 0; u < pc.p.length; u += 2) { xs.push(pc.p[u]); ys.push(pc.p[u + 1]); } pc.bb = [Math.min.apply(null, xs), Math.min.apply(null, ys), Math.max.apply(null, xs), Math.max.apply(null, ys)];
      });
      ready = true; layout(); setP(0);
      if ('IntersectionObserver' in window && !reduce) {
        var seen = false, io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && !seen) { seen = true; io.disconnect(); tween(1, 5200); } }); }, { threshold: .5 });
        io.observe(root);
      } else setP(1);
    }
    if (root.getAttribute('data-asm-vec')) { need = 1; } else { img.onload = go; img.src = root.getAttribute('data-asm-img'); }
    if (need === 3) { base.onload = go; base.src = root.getAttribute('data-asm-base'); }
    fetch(root.getAttribute('data-asm-json')).then(function (r) { return r.json(); }).then(function (j) { data = j; go(); });
  }
  function all() { Array.prototype.forEach.call(document.querySelectorAll('[data-mh][data-asm]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
